import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'missingValue'
})
export class MissingValuePipe implements PipeTransform {

  transform(value: any): string {
    return value !== null && value !== undefined && value !== '' ? value : '-';
  }

}
